import React, {useEffect} from "react";
import $ from 'jquery';
import {useNavigate, useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import axios from "axios";
import DateInput from "../../Components/Inputs/DateInput";
import {useForm} from "react-hook-form";

export default function () {
  const navigate = useNavigate();
  const token = useSelector(state => state.token);
  const {id} = useParams();

  const {register, watch, getValues} = useForm();

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_URL;

    let table = $('#discount-history').DataTable({
      "destroy": true,
      "bFilter": false,
      "ajax": {
        url: `${baseUrl}products/${id}/discount-history`,
        data: getValues(),
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.post('/logout')
              .then(res => {
                localStorage.removeItem('persist:root');
                navigate('/login');
              });
          }
        }
      },
      "columns": [
        {data: 'product.name', name: 'product.name'},
        {data: 'start_date', name: 'start_date'},
        {data: 'end_date', name: 'end_date'},
        {data: 'price', name: 'price'},
        {data: 'discount_price', name: 'discount_price'},
      ],
      order: [[1, 'desc']],
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");
  }, [watch('start_date'), watch('end_date')]);

  return (
    <div>

      <div className="row">

        <DateInput
          label="Start date"
          name="start_date"
          parentClasses="col-xxl-3 col-lg-6 mb-5"
          labelClasses="fs-7"
          title="mm/dd/yyyy"
          register={register}
        />

        <DateInput
          label="End date"
          name="end_date"
          parentClasses="col-xxl-3 col-lg-6 mb-5"
          labelClasses="fs-7"
          title="mm/dd/yyyy"
          register={register}
        />
      </div>

      <table id="discount-history" className="table align-middle table-row-dashed fs-6 gy-5">
        <thead>
        <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
          <th>Product</th>
          <th>Start date</th>
          <th>End date</th>
          <th>Price</th>
          <th>Discount price</th>
        </tr>
        </thead>
        <tbody className="text-gray-600 fw-bold">
        </tbody>
      </table>
    </div>
  );
}